export interface WorkspaceNavigationItem {
  href: string
  matchNested?: boolean
  search?: Record<string, string | boolean>
}

export function workspaceRelativeHref(pathname: string, href: string): string {
  const basePath = pathname.split('/').slice(0, 3).join('/')
  return `${basePath}${href}`
}

export function activeWorkspaceNavigationItem<
  T extends WorkspaceNavigationItem,
>(
  items: T[],
  pathname: string,
  search: Record<string, unknown> | undefined,
): T | undefined {
  const matchesPath = (item: T) => {
    const href = workspaceRelativeHref(pathname, item.href)
    return item.matchNested
      ? pathname === href || pathname.startsWith(`${href}/`)
      : pathname === href
  }
  const matchesSearch = (item: T) => {
    const entries = Object.entries(item.search ?? {})
    return (
      entries.every(
        ([key, value]) => String(search?.[key] ?? '') === String(value)
      ) &&
      Object.keys(search ?? {}).filter((key) => search?.[key] !== undefined)
        .length === entries.length
    )
  }

  const filteredItem = items.find(
    (item) =>
      Object.keys(item.search ?? {}).length > 0 &&
      matchesPath(item) &&
      matchesSearch(item)
  )
  if (filteredItem) return filteredItem

  return items.find(
    (item) => Object.keys(item.search ?? {}).length === 0 && matchesPath(item)
  )
}
